<ui-card class="loadable" [class.loading]="isLoading">
    <app-segment-header [title]="'time-off-v3.policyComponents.settings.general-settings.header'">
        <div class="buttons">
            <ui-button type="link" url="./edit"> {{ 'edit' | translate }} </ui-button>
        </div>
    </app-segment-header>

    <div class="field-container">
        <div class="label">
            {{ 'time-off-v3.policyComponents.settings.general-settings.timeOffLeaveVisibilityLabel' | translate }}:
        </div>
        <div>
            {{
                (timeOffVisibility
                    ? 'time-off-v3.policyComponents.settings.general-settings.timeOffLeaveNotVisible'
                    : 'time-off-v3.policyComponents.settings.general-settings.timeOffLeaveVisible'
                ) | translate
            }}
        </div>
    </div>

    <div class="field-container">
        <div class="label">
            {{ 'time-off-v3.policyComponents.settings.general-settings.timeOffBalanceDisplayDateLabel' | translate }}:
        </div>
        <div>
            {{
                (timeOffBalanceDateToday
                    ? 'time-off-v3.today'
                    : 'time-off-v3.policyComponents.settings.general-settings.yearEndHasTimeOffBalance'
                ) | translate
            }}
        </div>
    </div>

    <div class="field-container">
        <div class="label">
            {{ 'time-off-v3.policyComponents.settings.general-settings.backupApproverLabel' | translate }}:
        </div>
        <div>{{ approver | translate }}</div>
    </div>
</ui-card>
